import React from 'react';

export const Trads = {
  pageNotFound: {
    FR: "Oops! Page non trouvée",
    EN: "Oops! Page Not Found",
    DE: "Hoppla! Seite nicht gefunden",
    IT: "Oops! Pagina non trovata",
    ES: "¡Ups! Página no encontrada"
  },
  pageDoesNotExist: {
    FR: "Désolé, mais la page que vous recherchez n'existe pas",
    EN: "Sorry but the page you are looking for does not exist or is temporarily unavailable",
    DE: "Entschuldigung, aber die gesuchte Seite existiert nicht oder ist vorübergehend nicht verfügbar",
    IT: "Siamo spiacenti ma la pagina che stai cercando non esiste o è temporaneamente non disponibile",
    ES: "Lo sentimos, pero la página que está buscando no existe o no está disponible temporalmente"
  },
  establishmentNotFound: {
    FR: "Oops! Établissement non trouvé",
    EN: "Oops! Establishment not found",
    DE: "Hoppla! Einrichtung nicht gefunden",
    IT: "Oops, Stabilimento non trovato",
    ES: "¡Ups! Establecimiento no encontrado"
  },
  establishmentDoesNotExist: {
    FR: "Désolé, mais l'établissement que vous recherchez n'existe pas",
    EN: "Sorry but the establishment you are looking for does not exist or is temporarily unavailable",
    DE: "Entschuldigung, aber die Einrichtung, die Sie suchen, existiert nicht",
    IT: "Spiacenti, ma lo stabilimento che stai cercando non esiste",
    ES: "Lo sentimos, pero el establecimiento que busca no existe"
  },
  customer_area_not_found: {
    FR: "Espace client non trouvé",
    EN: "Customer area not found",
    DE: "Kundenbereich nicht gefunden",
    IT: "Area clienti non trovata",
    ES: "Area de cliente no encontrada"
  },
  wrong_password: {
    FR: "Mot de passe incorrect",
    EN: "Wrong password",
    DE: "Falsches Passwort",
    IT: "Password errata",
    ES: "Contraseña incorrecta"
  },
  error_connection: {
    FR: "Erreur de connexion",
    EN: "Connection error",
    DE: "Verbindungsfehler",
    IT: "Errore di connessione",
    ES: "Error de conexión"
  }
}